// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CartRouteImport } from './routes/cart'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as WishlistRouteImport } from './routes/wishlist'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as AccountSectionRouteImport } from './routes/account.$section'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAccountRouteImport } from './routes/admin.account'
import { Route as AdminAnnouncementsRouteImport } from './routes/admin.announcements'
import { Route as AdminCategoriesRouteImport } from './routes/admin.categories'
import { Route as AdminFooterRouteImport } from './routes/admin.footer'
import { Route as AdminNavRouteImport } from './routes/admin.nav'
import { Route as AdminOrdersRouteImport } from './routes/admin.orders'
import { Route as AdminProductsRouteImport } from './routes/admin.products'
import { Route as AdminSeoRouteImport } from './routes/admin.seo'
import { Route as AdminSlidesRouteImport } from './routes/admin.slides'
import { Route as AdminSocialRouteImport } from './routes/admin.social'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminWhatsappRouteImport } from './routes/admin.whatsapp'
import { Route as AdminWhatsappOrdersRouteImport } from './routes/admin.whatsapp-orders'
import { Route as GuidesIndexRouteImport } from './routes/guides.index'
import { Route as GuidesSlugRouteImport } from './routes/guides.$slug'
import { Route as ProductSlugRouteImport } from './routes/product.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const OrdersRoute = OrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const WishlistRoute = WishlistRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => rootRouteImport
          })
const AccountIndexRoute = AccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => rootRouteImport
          })
const AccountSectionRoute = AccountSectionRouteImport.update({
            id: '/account/$section',path: '/account/$section',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminAccountRoute = AdminAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AdminRoute
          })
const AdminAnnouncementsRoute = AdminAnnouncementsRouteImport.update({
            id: '/announcements',path: '/announcements',getParentRoute: () => AdminRoute
          })
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => AdminRoute
          })
const AdminFooterRoute = AdminFooterRouteImport.update({
            id: '/footer',path: '/footer',getParentRoute: () => AdminRoute
          })
const AdminNavRoute = AdminNavRouteImport.update({
            id: '/nav',path: '/nav',getParentRoute: () => AdminRoute
          })
const AdminOrdersRoute = AdminOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AdminRoute
          })
const AdminProductsRoute = AdminProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => AdminRoute
          })
const AdminSeoRoute = AdminSeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => AdminRoute
          })
const AdminSlidesRoute = AdminSlidesRouteImport.update({
            id: '/slides',path: '/slides',getParentRoute: () => AdminRoute
          })
const AdminSocialRoute = AdminSocialRouteImport.update({
            id: '/social',path: '/social',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const AdminWhatsappRoute = AdminWhatsappRouteImport.update({
            id: '/whatsapp',path: '/whatsapp',getParentRoute: () => AdminRoute
          })
const AdminWhatsappOrdersRoute = AdminWhatsappOrdersRouteImport.update({
            id: '/whatsapp-orders',path: '/whatsapp-orders',getParentRoute: () => AdminRoute
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/guides/$slug',path: '/guides/$slug',getParentRoute: () => rootRouteImport
          })
const ProductSlugRoute = ProductSlugRouteImport.update({
            id: '/product/$slug',path: '/product/$slug',getParentRoute: () => rootRouteImport
          })





const AdminRouteChildren = {
  AdminAccountRoute: AdminAccountRoute,AdminAnnouncementsRoute: AdminAnnouncementsRoute,AdminCategoriesRoute: AdminCategoriesRoute,AdminFooterRoute: AdminFooterRoute,AdminNavRoute: AdminNavRoute,AdminOrdersRoute: AdminOrdersRoute,AdminProductsRoute: AdminProductsRoute,AdminSeoRoute: AdminSeoRoute,AdminSlidesRoute: AdminSlidesRoute,AdminSocialRoute: AdminSocialRoute,AdminUsersRoute: AdminUsersRoute,AdminWhatsappRoute: AdminWhatsappRoute,AdminWhatsappOrdersRoute: AdminWhatsappOrdersRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,AuthRoute: AuthRoute,CartRoute: CartRoute,CheckoutRoute: CheckoutRoute,OrdersRoute: OrdersRoute,ShopRoute: ShopRoute,WishlistRoute: WishlistRoute,AccountSectionRoute: AccountSectionRoute,GuidesSlugRoute: GuidesSlugRoute,ProductSlugRoute: ProductSlugRoute,AccountIndexRoute: AccountIndexRoute,GuidesIndexRoute: GuidesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)